module.exports = __webpack_public_path__ + "svg_80x80/bottle.2be6ce.svg";